import type { FC } from "react";

import { usePartner } from "@/sdk";
import { useFeatureFlag } from "@/shared-utils";

import { ExpertUniversityLearningBlocks } from "./ascend/ExpertUniversityLearningBlocks";
import { ExpertUniversityHome } from "./ExpertUniversityHome";

/**
 * Routes the Expert University takeover to the right experience based on the
 * `EWP-isInASCENDTrainingPilot` flag: experts in the ASCEND training pilot get the
 * learning-blocks view, everyone else gets the existing Expert University home. Until the
 * flag resolves it is falsy, so home is the default (matching pre-pilot behavior).
 */
export const ExpertUniversityExperience: FC = () => {
    const partner = usePartner();
    const { data: isInAscendTrainingPilot } = useFeatureFlag<boolean>("EWP-isInASCENDTrainingPilot", { partner });

    return isInAscendTrainingPilot ? <ExpertUniversityLearningBlocks /> : <ExpertUniversityHome />;
};
